import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addLabTests = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/method/technoerp.services.create_labtest',
    body
  );
  return data;
});

export const getLabTests = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_labtests'
  );
  return data;
});
export const deleteLabTests = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/method/technoerp.services.delete_record?record=${record}&document=Lab Test`
  );
  return data;
});
export const getLabTestsDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/method/technoerp.services.get_labtests?labtest=${id}`
  );
  return data;
});
export const getMedicalCodes = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_medical_codes'
  );
  return data;
});
export const getLabTestTemplates = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_labtest_templates'
  );
  return data;
});
export const getPractitioners = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_practitioners'
  );
  return data;
});
export const getEmployees = catchAsync(async () => {
  const { data } = await axiosInstance.get(
    '/api/method/technoerp.services.get_employees'
  );
  return data;
});
